/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Ronnel Bedana - ronnel@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { Component, OnDestroy } from '@angular/core';
import { Subscription, Subject } from 'rxjs';
import { ErrorNotificationService, UserService } from '../../../services';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ErrorDetailsModal } from './error-details/error-details.modal';
import { CrmError } from 'src/app/model/error';
import { ErrorProvider } from 'src/app/providers/error.provider';
import { Helpers, User } from 'src/app/model';
import { FeedbackModal } from './feedback/feedback.modal';
import { LogService } from 'src/app/services';

@Component({
  selector: 'app-toast',
  templateUrl: 'toast.component.html',
  styleUrls: ['toast.component.scss'],
})

export class ToastComponent implements OnDestroy {
  private subscription: Subscription;
  messages: any[] = [];
  detailRef: BsModalRef;
  feedbackRef: BsModalRef;

  constructor(
    private errorService: ErrorNotificationService,
    private modalService: BsModalService,
    private errorProvider: ErrorProvider,
    private userService: UserService,
    private logService :LogService) {

    this.subscription = this.errorService.getError().subscribe(data => {
      if (data) {
        if (!this.messages.find(message => message.error.HASH === data.error.HASH)) {
          this.messages.push(data);
        }
      }
    });
  }

  ngOnDestroy(): void {
    // unsubscribe on destroy to prevent memory leaks
    if (this.subscription)
      this.subscription.unsubscribe();
  }

  close(index: number): void {
    this.messages.splice(index, 1);
  }

  sendReport(details: CrmError): void {
    this.detailRef = this.modalService.show(ErrorDetailsModal, Helpers.getModalConfig());
    const ackSubject = new Subject<boolean>();
    this.detailRef.content.subject = ackSubject;
    this.detailRef.content.details = details;
    details.URL = window.location.href;

    ackSubject.subscribe(value => {
      if (value) {
        this.messages.splice(this.messages.indexOf(details), 1);
      }
    });
  }

  onSendFeedBack(): void {
    const details: CrmError = new CrmError();
    details.TYPE = null;
    details.DATE = new Date();
    details.USER = User.parse(this.userService.getCurrentUser()),
    details.MESSAGE = '';
    details.URL = window.location.href;

    this.feedbackRef = this.modalService.show(FeedbackModal, Helpers.getModalConfig());
    const ackSubject = new Subject<boolean>();
    this.feedbackRef.content.subject = ackSubject;
    this.feedbackRef.content.details = details;


    ackSubject.subscribe(value => {
      if (value) {
        this.errorProvider.sendFeedback(details)
          .subscribe(data => {
            if (!data.success) {
              this.logService.error(JSON.stringify(data, null, 2));
            }
          });
      }
    });
  }
}
